import { ServerFetch } from '../main-model'

export default class PurchaseReturnListModel extends ServerFetch {
    getPurchaseReturnListBy = (data) => this.authFetch({
        url: 'purchase-return-list/getPurchaseReturnListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    generatePurchaseReturnListBy = (data) => this.authFetch({
        url: 'purchase-return-list/generatePurchaseReturnListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}